<script setup>
import orientationSvg from '@/assets/orientation.svg'
</script>

<template>
  <div class="hidden landscape:block fixed inset-0 z-99999 bg-black/50">
    <div
      class="absolute top-1/2 left-1/2 w-80 -translate-x-1/2 -translate-y-1/2 rounded-md bg-white p-5"
    >
      <div class="mb-4 text-center text-[17px] font-bold leading-5.5">
        {{ $t('orientation.turn_device') }}
      </div>
      <div class="flex">
        <div class="shrink-0 text-center">
          <img
            :src="orientationSvg"
            alt="orientation"
            height="100"
            width="100"
          />
        </div>
        <div class="mt-4 px-4 text-[13px] leading-4.5">
          {{ $t('orientation.vertically') }}
        </div>
      </div>
    </div>
  </div>
</template>
